import React from 'react';
import { AlertTriangleIcon, ChevronRightIcon } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
import { considerations, scenarios } from '../data/content';
export function ProblemSection() {
  return <section className="w-full bg-ivory px-5 py-16 md:px-8 md:py-24" data-id="element-245" data-mp="30hzi12evdwlw">
      <div className="mx-auto max-w-4xl" data-id="element-246" data-mp="2vpzc8tc4c9he">
        <h2 className="text-center font-serif text-[1.85rem] font-extrabold leading-tight text-navy-900 sm:text-4xl md:text-5xl" data-id="element-247" data-mp="2vowo2t66kl56">
          When a veneer complication appears, the hardest part isn’t always identifying the
          problem.
        </h2>
        <p className="mt-5 text-center text-lg font-semibold text-gold-600 sm:text-xl" data-id="element-248" data-mp="3jgljiieatpqc">
          It’s organizing everything that needs to be evaluated before deciding what comes next.
        </p>

        <div className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-249" data-mp="1p1ixwvsdersp">
          {scenarios.map(s => <div key={s.title} className="flex flex-col rounded-2xl bg-white p-6 shadow-sm ring-1 ring-navy-900/5" data-id="element-250" data-mp="1k37oun9wglbj">
              <AlertTriangleIcon className="h-7 w-7 text-gold-500" aria-hidden="true" data-id="element-251" data-mp="jdwmx3wkbyzj" />
              <h3 className="mt-3 text-lg font-bold text-navy-900" data-id="element-252" data-mp="obonemb9wtfc">{s.title}</h3>
              <p className="mt-2 text-base leading-relaxed text-muted" data-id="element-253" data-mp="sdthtn9jpu31">{s.text}</p>
            </div>)}
        </div>

        <p className="mt-10 text-center text-lg leading-relaxed text-ink" data-id="element-254" data-mp="x4rxckmpmo58">
          Each situation presents different clinical questions. And each requires{' '}
          <strong data-id="element-255" data-mp="125z3ygd49hab">more than a quick visual assessment.</strong>
        </p>

        <div className="mt-10 rounded-3xl bg-navy-900 p-6 text-white sm:p-10" data-id="element-256" data-mp="170uzhqhkams6">
          <h3 className="font-serif text-2xl font-bold text-gold-300" data-id="element-257" data-mp="1c33vkvpqe4yi">You may need to consider:</h3>
          <ul className="mt-5 space-y-3.5" data-id="element-258" data-mp="1g22y69nzppms">
            {considerations.map(c => <li key={c} className="flex gap-3 text-base leading-relaxed sm:text-lg" data-id="element-259" data-mp="3du785qj6ltlp">
                <ChevronRightIcon className="mt-1 h-5 w-5 shrink-0 text-gold-400" aria-hidden="true" data-id="element-260" data-mp="3htz7dcmoqnee" />
                {c}
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-12 max-w-3xl space-y-5 text-lg leading-relaxed text-ink" data-id="element-261" data-mp="k1fmlwbr7ddb">
          <p data-id="element-262" data-mp="y0p2euw1s5gr">
            <strong className="text-navy-900" data-id="element-263" data-mp="y1go9dzueotu">The challenge?</strong> These findings don’t always
            arrive in a neat, organized sequence.
          </p>
          <p data-id="element-264" data-mp="u1g5xi9mhthi">
            Without a consistent documentation and decision framework, important observations can
            become scattered across clinical notes, photographs, examination findings, and treatment
            discussions.
          </p>
          <p data-id="element-265" data-mp="1hnwgssp6xauu">
            And when the information is scattered, building a clear corrective plan becomes more
            demanding.
          </p>
          <p className="border-l-4 border-gold-500 pl-5 font-serif text-2xl font-bold leading-snug text-navy-900" data-id="element-266" data-mp="1cs7e4ghvjdub">
            What if every veneer complication case started with the same structured assessment
            pathway?
          </p>
          <p data-id="element-267" data-mp="25c1r33e65s5z">
            Not a rigid treatment recipe. Not a collection of theoretical chapters. But a practical
            framework that helps you organize the case, identify unresolved questions, and document
            your professional reasoning.
          </p>
          <p data-id="element-268" data-mp="20d8ah23l5l1l">
            That’s exactly what the <strong data-id="element-269" data-mp="20c71r4a1lan1">Dental Veneer Complications Blueprint™</strong> was
            designed to support.
          </p>
        </div>

        <SectionCTA label="I Want an Organized Assessment Pathway" data-id="element-270" data-mp="1mkilcosrg009" />
      </div>
    </section>;
}